module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate15.c8027a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate15.png
// module id = 750
// module chunks = 0